import { fetcher } from '@commenda/utils';

export async function deleteIndirectTaxRegistration(
  registrationId: string,
  corporationId: number
): Promise<{ success: boolean; error?: string }> {
  try {
    const query = new URLSearchParams();
    query.append('corporationId', corporationId?.toString());

    const response = await fetcher(
      `new-sales-tax/registrations-v2/${registrationId}?${query}`,
      { method: 'DELETE' },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to delete registration',
      };
    }

    return { success: true };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to delete registration';
    return { success: false, error: errorMessage };
  }
}
